import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff, LogIn } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_c66cef96-8aba-458e-b39b-120deb34b863/artifacts/in70evo4_QUINIELA%20LOGO.png';

export default function Login() {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(userId, password);
      navigate(user.role === 'admin' ? '/admin' : '/');
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Error al iniciar sesion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A1220] flex flex-col items-center justify-center p-4 sparkle-bg" data-testid="login-page">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A1220] via-[#0E1828] to-[#0A1220] opacity-90" />

      <div className="relative z-10 flex flex-col items-center w-full max-w-sm lg:max-w-md animate-fade-in">
        <img src={LOGO_URL} alt="Quiniela Mundial 2026" className="w-40 h-40 lg:w-48 lg:h-48 mb-6 drop-shadow-2xl" data-testid="login-logo" />

        <div className="w-full login-card-custom p-8 lg:p-10">
          <h1 className="text-3xl lg:text-4xl font-black text-center mb-2 text-[#D4C48C] italic" style={{ fontFamily: 'Montserrat' }} data-testid="login-title">
            ¡Bienvenido!
          </h1>
          <p className="text-[#B0A070] text-center text-sm mb-6">Ingresa a tu cuenta para participar</p>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="text-[#C6C6C6] text-sm font-medium mb-2 block">ID</label>
              <input
                type="text"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                placeholder="ID de usuario"
                data-testid="login-userid-input"
                className="w-full bg-transparent border border-[#B89E5A] rounded-md px-4 py-3 text-white placeholder-[#857C62] placeholder:opacity-90 focus:border-[#E1D196] focus:ring-1 focus:ring-[#E1D196]/50 outline-none transition-all"
                required
              />
            </div>

            <div>
              <label className="text-[#C6C6C6] text-sm font-medium mb-2 block">Contraseña</label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="........"
                  data-testid="login-password-input"
                  className="w-full bg-transparent border border-[#B89E5A] rounded-md px-4 py-3 text-white placeholder-[#857C62] placeholder:opacity-90 focus:border-[#E1D196] focus:ring-1 focus:ring-[#E1D196]/50 outline-none transition-all pr-12"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-[#857C62] hover:text-white transition-colors"
                  data-testid="toggle-password"
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            {error && (
              <p className="text-red-400 text-sm text-center" data-testid="login-error">{error}</p>
            )}

            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full login-btn-custom py-3.5 rounded-lg flex items-center justify-center gap-2 text-base font-bold"
            >
              <LogIn size={18} />
              INGRESAR
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
